
export const declineReasons = {
    'work_conflict': 'The date conflicts with existing work commitments',
    'personal_conflict': 'The date conflicts with existing personal commitments',
    'against_policy': 'Acceptance is against company policy',
    'already_there': 'I am already attending the event as a guest of another company',
    'other': 'Other',
};

